import { NumberInput } from "@tellescope/ui";
import { cn } from "@tellescope/utils";
import { TellescopeFormFieldBaseProps } from "../types";

export interface NumberFieldProps extends TellescopeFormFieldBaseProps<"number"> {}

export const NumberField = ({ title, value, onChange, className, error, onBlur, touched }: NumberFieldProps) => {
  const showError = !!(error && touched);

  return (
    <div>
      {!!title && <h4>{title}</h4>}
      <NumberInput
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={cn(className, showError && "border-destructive")}
        aria-invalid={showError}
      />
      {showError && <p className="text-sm text-destructive mt-1">{error}</p>}
    </div>
  );
};
